import React, { useEffect, useState } from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
import { Dancing_Script } from "next/font/google";
import { useTranslation } from "@/contexts/TranslationContext";

const ds = Dancing_Script({
  weight: ["400", "500", "600", "700"],
  subsets: ["latin"],
});

export default function PastEventsSlider() {
  const { t } = useTranslation();
  const [images, setImages] = useState([]);

  useEffect(() => {
    const loadImages = async () => {
      try {
        const url =
          "/api/products" +
          "?filters[product_status][$eq]=unlisted" +
          "&populate[images][fields][0]=url" +
          "&populate[product_variants][populate][images][fields][0]=url";

        const res = await fetch(url);
        const json = await res.json();

        const mappedImages = json.data
          .map((p) => {
            const v = p.product_variants?.[0];
            const rawImage =
              v?.images?.[0]?.url || p.images?.[0]?.url;

            return rawImage || null;
          })
          .filter(Boolean); // nullok kiszűrése

        setImages(mappedImages);
      } catch (e) {
        console.error("Past events load error:", e);
      }
    };

    loadImages();
  }, []);

  return (
    <div className="relative w-full bg-white">
      {/* Felső fekete sáv */}
      <div className="bg-black text-center py-12 relative">
        <h2
          className={`${ds.className} text-[#fe64db] text-2xl md:text-3xl relative z-10`}
        >
          {t("past_events.title")}
        </h2>
      </div>

      {/* Slider */}
      <div className="w-full h-[200px] my-12 overflow-hidden">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={30}
          slidesPerView={5}
          loop
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          speed={1000}
          breakpoints={{
            0: { slidesPerView: 1 },
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 5 },
          }}
        >
          {images.map((image, index) => (
            <SwiperSlide
              key={index}
              className="flex items-center justify-center"
            >
              <div className="relative w-full h-[200px] flex items-center justify-center overflow-hidden">
                <Image
                  src={image}
                  alt={`Past Event ${index + 1}`}
                  fill
                  unoptimized
                  className="object-contain"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Alsó fekete sáv */}
      <div className="bg-black relative py-12"></div>
    </div>
  );
}
